import {
  Dialog,
  Flex,
  Text,
  DialogTitle,
  DialogActions,
  Button,
  List,
  ListItem,
} from '@shared/components';

export interface ExamAssigningResultModalProps {
  results?: {
    examCoursesChosen: number;
    examEventsAssigned: number;
  };
  open: boolean;
  onClose?: () => void;
}

export default function ExamAssigningResultModal(props: Readonly<ExamAssigningResultModalProps>) {
  const { open: isOpen, results, onClose } = props;

  return (
    <Dialog open={isOpen} maxWidth='xs'>
      <DialogTitle>มอบหมายชุดข้อสอบเรียบร้อยแล้ว</DialogTitle>
      <Flex
        sx={{
          flexDirection: 'column',
          px: (theme) => theme.spacing(6),
        }}
      >
        <List sx={{ listStyle: 'disc', p: (theme) => theme.spacing(0, 0, 0, 6) }}>
          <ListItem
            sx={{
              display: 'list-item',
              p: (theme) => theme.spacing(0),
            }}
          >
            <Flex>
              <Text>รอบสอบที่มอบหมายแล้ว: </Text>
              <Text variant='body1Semibold'>{results?.examEventsAssigned} รอบ</Text>
            </Flex>
          </ListItem>
          <ListItem
            sx={{
              display: 'list-item',
              p: (theme) => theme.spacing(0),
            }}
          >
            <Flex>
              <Text>หลักสูตรที่เลือก: </Text>
              <Text variant='body1Semibold'>{results?.examCoursesChosen} หลักสูตร</Text>
            </Flex>
          </ListItem>
        </List>
      </Flex>
      <DialogActions>
        <Button size='large' onClick={onClose}>
          เสร็จสิ้น
        </Button>
      </DialogActions>
    </Dialog>
  );
}
